import { Edit24, DataView24 } from "@carbon/icons-react";
import React, { useState, useEffect } from "react";
import Card from "../../components/Card/Card";
import http from "../../http-common";
import PaginatedDataTable from "../../components/Table/PaginatedDataTable";
import DataOperationButton from "../../components/Buttons/DataOperationButton";
import AddEntityButton from "../../components/Buttons/AddEntityButton";
import { buildSearchQuery, setPaging } from "../../services/Utils";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const tableHeaders = [
  {
    header: "Título",
    key: "title",
  },
  {
    header: "Empresa",
    key: "companyName",
  },
  {
    header: "Duração",
    key: "duration",
  },
  {
    header: "Província",
    key: "provinceName",
  },
  {
    header: "Distrito",
    key: "districtName",
  },
  {
    header: "Data Início",
    key: "recruitmentStartDate",
  },
  {
    header: "Data Fim",
    key: "recruitmentEndDate",
  },
  {
    header: "Nr de Vagas",
    key: "numberOfVacancies",
  },
  {
    header: "Operação",
    key: "actions",
  },
];

const ListVacanciesPage = () => {
  const [uri, setUri] = useState("/internships/vacancies/q?");
  const [showSpinner, setShowSpinner] = useState(true);
  const [query, setQuery] = useState("");
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalElements, setTotalElements] = useState(0);
  const { user, isCompetitor, isWinner } = useContext(AuthContext);
  const [company, setCompany] = useState(null);
  const navigate = useNavigate();

  const getData = async (url) => {
    try {
      const response = await http.get(url);
      setItems(response.data.content);
      setTotalElements(response.data.totalElements);
      setPageSize(response.data.size);
      setPage(response.data.number + 1);
      setShowSpinner(false);
    } catch (error) {}
  };

  const getCellContent = (cell, id) => {
    if (cell.info.header === "actions") {
      return (
        <DataOperationButton
          operations={[
            {
              id: id,
              url: `../vagas-para-estagio/${id}`,
              icon: isWinner ? Edit24 : DataView24,
              title: isWinner ? "Edit" : "Consultar",
            },
          ]}
        />
      );
    }

    return cell.value;
  };

  const onSearch = async (data) => {
    try {
      const q = buildSearchQuery(data);
      setQuery(q);
      getData(`${uri}${q}`);
    } catch (error) {}
  };

  const onPageChange = async (pageInfo) => {
    try {
      getData(`${uri}${query}${setPaging(pageInfo)}`);
    } catch (error) {}
  };

  const loadCompany = async () => {
    try {
      const response = await http.get(
        `/internships/companies/nur/NUR${user.username}`
      );
      setCompany(response.data);
      console.log(response.data);
      setUri(`/internships/vacancies/q?companyId=${response.data.id}`);
    } catch (error) {
      // navigate("../inicio/");
    }
  };

  useEffect(() => {
    console.log(isWinner);
    if (isWinner) {
      loadCompany();
    }
    getData(`${uri}`);
  }, [uri]);

  return (
    <Card title="Vagas de Estágio" showSpinner={showSpinner}>
      {isWinner && (
        <AddEntityButton
          label="Registar Vaga"
          kind="ghost"
          url="../registar-vaga"
        />
      )}
      <PaginatedDataTable
        headers={tableHeaders}
        items={items}
        onPageChange={onPageChange}
        onSearch={onSearch}
        page={page}
        pageSize={pageSize}
        totalElements={totalElements}
        getCellContent={getCellContent}
      ></PaginatedDataTable>
    </Card>
  );
};

export default ListVacanciesPage;
